module.exports = __webpack_public_path__ + "img/cbt_btn_close.83075dda.png";